<div class="row row-sm">
	<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
		<div class="card custom-card">
			<div class="dashboard-top">
				<button mat-icon-button  color="primary" (click)="reload()">
						<mat-icon>sync</mat-icon>
				</button>
			</div>
			<div class="dashboard-header">
				<button type="button" (click)="goBack()" mat-button>
					<mat-icon>chevron_left</mat-icon>
				</button>
				<h2 class="webapp-title-secondary">Client List</h2>
        	</div>
			<div class="card-header border-bottom-0 pb-0 margin-bt-1rem">
				<div class="d-flex justify-content-between">
				</div>
				<p class="tx-12 tx-gray-500 mt-0 mb-2">All the clients that we have processed form all the different input sources. <a href="javascript: void(0)" (click)="goToPage('client-board')">Client Board</a></p>
			</div>
			<div class="custom-card">
				<div class="table-responsive border">
					<table class="table card-table table-striped table-vcenter text-nowrap mb-0">
						<thead>
							<tr>
								<th class="wd-lg-8p"><span></span></th>
								<th class="wd-lg-20p"><span>Full name</span></th>
								<th class="wd-lg-8p"><span>First Contact Date</span></th>
								<!-- <th class="wd-lg-20p"><span>Career</span></th> -->
								<th class=""><span>Country</span></th>
								<th class=""><span>Email</span></th>
							</tr>
						</thead>
						<mat-spinner *ngIf="isLoading()"></mat-spinner>
						<tbody *ngIf="!isLoading()">
							<tr *ngFor="let row of clients">
								<td>
									<img *ngIf="!row.imageUrl" alt="avatar" class="rounded-circle avatar-md" src="{{getImageUrl('avatar-default-icon.png')}}">
									<img *ngIf="row.imageUrl" alt="avatar" class="rounded-circle avatar-md" src="{{getImageUrl(row.imageUrl)}}">
								</td>
								<td>
									({{row.id}})  {{row.name}} {{row.lastname}}
								</td>
								<td>
									{{row.firstContactDate}}
								</td>
								<!-- <td>
									<app-smart-text [limit]="28" [text]="row.career"></app-smart-text>
								</td> -->
								<td>
									<p>{{row.country}}</p>
								</td>
								<td>
									<a href="javascript: void(0)" (click)="copyToClipbooard(row)">{{row.email}}</a>
								</td>
								
							</tr>
						</tbody>
					</table>
				</div>

			</div>
		</div>
	</div><!-- COL END -->
</div>
